import produce from 'immer';
import { BundleDetailDto } from '../../models/models';
import { Bundle } from '../bosatlas/bosatlas.types';
import {
	BUNDLE_LOAD_LIST,
	BUNDLE_LOAD,
	BUNDLE_DELETE_COMPLETE
} from './bundles.actions';
import { BundleActions, IBundleState } from './bundles.types';

const bundleInitialState: IBundleState = {};

export function bundleReducer(
	state: IBundleState = bundleInitialState,
	action: BundleActions
): IBundleState {
	switch (action.type) {
		case BUNDLE_LOAD_LIST: {
			return replaceBundleList(state, action.payload as Bundle[]);
		}
		case BUNDLE_LOAD: {
			return replaceBundle(state, action.payload as BundleDetailDto);
		}
		case BUNDLE_DELETE_COMPLETE: {
			return deleteBundle(state, action.payload as BundleDetailDto);
		}
		default: {
			return state;
		}
	}
}

function deleteBundle(
	currentState: IBundleState,
	bundle: BundleDetailDto
): IBundleState {
	return produce(currentState, (draftState: IBundleState) => {
		draftState.bundleList = currentState.bundleList?.filter(
			(x) => x.id !== bundle.id
		);
	});
}

function replaceBundle(
	currentState: IBundleState,
	bundle: BundleDetailDto
): IBundleState {
	return produce(currentState, (draftState: IBundleState) => {
		draftState.bundle = bundle;
	});
}

function replaceBundleList(
	currentState: IBundleState,
	bundles: Bundle[]
): IBundleState {
	return produce(currentState, (draftState: IBundleState) => {
		draftState.bundleList = bundles;
	});
}
